import { Observable, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';

import { ISnListQueryParameters } from '@lib/api';
import { FsDataDogRumService } from '@lib/data-dog-rum';
import { LprIntegrationType } from '@lib/data-dog-rum/custom-action-map';

import { FsEagleEyeRead } from '../api';
import {
  extractLprErrorCode,
  extractLprRawError,
  parseLprApiError,
} from '../utils/lpr-error-utils';

@Injectable({
  providedIn: 'root',
})
export class EagleEyeLprService implements OnDestroy {
  private readonly _destroy$ = new Subject<void>();
  private readonly _integrationType: LprIntegrationType = 'eagleeye';

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _metrics: FsDataDogRumService,
  ) {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public getEagleEyePlates(params: ISnListQueryParameters): Observable<any> {
    const startTime = Date.now();

    return this._httpClient
      .get('/api/integrations/eagleeyenetworks/plate_search/', { params })
      .pipe(
        map((response: any) => {
          const result = {
            count: response.count,
            links: response.links,
            eagleEyeNetworksData: response.eagleEyeNetworksData,
            totalPages: response.totalPages,
            results: response.results.map((read) => new FsEagleEyeRead(read)),
            isEagleEye: true,
          };

          this._metrics.addAction('lpr_search', {
            status: response.status || 200,
            duration_ms: Date.now() - startTime,
            integration: this._integrationType,
          });

          return result;
        }),
        catchError((error) => {
          this._metrics.addAction('lpr_search_error', {
            status: error?.status || 500,
            duration_ms: Date.now() - startTime,
            integration: this._integrationType,
            raw_error: extractLprRawError(error),
            error_code: extractLprErrorCode(error),
            error_message: parseLprApiError(error),
          });

          throw error;
        }),
      );
  }

  public destroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
